"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Functions = void 0;
const react_1 = require("@chakra-ui/react");
const react_2 = __importDefault(require("react"));
const UiKitLite_1 = require("../UiKitLite");
const FunctionName = (props) => {
    const args = props.args;
    return (react_2.default.createElement("code", null,
        react_2.default.createElement("span", { style: { color: UiKitLite_1.UiKitLite.consistency.primaryBlue50 } },
            "UiKit.Function.",
            props.functionName,
            "(",
            args.map((arg, index) => {
                const isNotLastArg = index < args.length - 1;
                return (react_2.default.createElement("span", { style: { color: UiKitLite_1.UiKitLite.consistency.gray90 }, key: index },
                    arg,
                    isNotLastArg ? ', ' : ''));
            }),
            ")")));
};
const Functions = () => {
    const text = 'File content line 1\n\
  File content line 2\n\
  File content line 3\n';
    return (react_2.default.createElement(react_1.VStack, { alignItems: 'flex-start', spacing: UiKitLite_1.UiKitLite.consistency.buffer },
        react_2.default.createElement("code", null,
            react_2.default.createElement(FunctionName, { functionName: 'downloadFile', args: ['fileText', 'fileName'] })),
        react_2.default.createElement(UiKitLite_1.UiKitLite.Button.Primary, { leftIcon: 'download', text: 'Click to download', onClick: () => UiKitLite_1.UiKitLite.Function.downloadFile(text, 'UiKit Download Example.txt') }),
        react_2.default.createElement(react_1.Divider, null),
        react_2.default.createElement(FunctionName, { functionName: 'trimToEllipsis', args: ['longString', 'maxStrLength', "'end' | 'middle'"] }),
        react_2.default.createElement("code", null,
            "123456789 > ",
            UiKitLite_1.UiKitLite.Function.trimToEllipsis('123456789', 5, 'middle')),
        react_2.default.createElement("code", null,
            "123456789 > ",
            UiKitLite_1.UiKitLite.Function.trimToEllipsis('123456789', 5, 'end'))));
};
exports.Functions = Functions;
